import React from 'react';
import styled from 'styled-components';
import { components, SingleValueProps } from 'react-select';

import { DropdownArrow } from '@icons/common';
import theme from '../../../styles/userflow';

const { SingleValue } = components;

const CustomSingleValue = ({ children, ...props }: SingleValueProps<any>) => (
  <SingleValue {...props}>
    {children}
    <StyledDropdownArror />
  </SingleValue>
);

const StyledDropdownArror = styled(DropdownArrow)`
  margin-left: 4px;
  stroke: ${theme.colors.blue};
  width: 12px;
  height: 6px;
`;

export default CustomSingleValue;
